import {
  Component,
  Inject,
  OnInit,
  AfterViewInit,
  HostListener
} from '@angular/core';
import {
  Router,
  ActivatedRoute,
  Params
} from '@angular/router';
import {
  GlobalSettings
} from './global.settings';
import {
  CommonService
} from './common.service';
import { IndexedDBService } from './services/indexed-db.service';
import Utils from './utils';
import {
  HttpClient
} from '@angular/common/http';
import {
  Observable
} from 'rxjs';
import { UtilsService } from './utils.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})

export class AppComponent implements OnInit, AfterViewInit {
  isPublic = false;
  selectedTopMenu = ''; // holds the selected tab based on route path
  currentURL = ''; // holds the current url
  searchPlaceholder; // holds the place holder for search input box
  searchTrigger = false; // holds the boolean condition for search component to toggle
  orgCode = ''; // holds the org code from the url
  orgId = ''; // holds the org id from the url
  showMaintenance = false; // holds boolean to determine maintenance activity
  orgLogoPath = ''; // holds logo path

  /**
   * Add the window resize event
   * @param event window resize event
   */
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    if (event) {
      this.utilsService.assetPanelHeight();
      this.utilsService.exemplarAssetPanelHeight();
      this.utilsService.additionalMetadataPanelHeight();
      this.utilsService.pacingGuideDetailsHeightCalculation();
      this.utilsService.searchHeightCalculation(true); // send true for only resize console event
      this.utilsService.pacingGuideHeightCalculation();
      this.utilsService.publicReviewHeightCalculation();
      this.utilsService.frontFacetaxonomyDetailsHeightCal();
      this.utilsService.customTaxonomyHeightCal();
      this.utilsService.jasperReportHeightCal();
      this.utilsService.reportTabHeightCalculation();
    }
  }

  /**
   * Add the window popstate event for the modal open
   * @param event window popstate event
   */
  @HostListener('window:popstate',['$event'])
  onPopState(event: any) {
    document.body.classList.remove('modal-open');
    const visibility = 'visibility:hidden' ;
    document.getElementsByClassName('modal')[0].setAttribute('style', visibility);
  }

  /**
   * Add the window touch move event
   * @param event event for the touch move
   */
  @HostListener('window:touchmove', ['$event'])
  onTouchMove(event) {
    if (event.touches) {
      this.utilsService.preventBehavior(event);
    }
  }

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private service: CommonService,
    @Inject('Window') private window: Window,
    private idb: IndexedDBService,
    private http: HttpClient,
    private utilsService: UtilsService
  ) {
    sessionStorage.clear();
    GlobalSettings.BASE_URL = 'https://api.' + GlobalSettings.HOSTNAME + '/server/'; //'https://acmt-qa.learningmate.com/server/';
    this.service.baseURL = GlobalSettings.BASE_URL;
    Utils.indexedDBServiceObj = idb;
    localStorage.setItem('project_role_permissions', '');
    this.isPublic = false;
    this.activatedRoute.params.subscribe((params: Params) => {
      console.log('$$ PARAMS in APP', params, this.service.baseURL);
      const org = JSON.parse(localStorage.getItem('orgDetails'));
      const cookieObj = document.cookie;
      let SSOUser;
      if (cookieObj.indexOf('SSOUser') !== -1 && cookieObj.indexOf('central_auth_token') !== -1) {
        SSOUser = JSON.parse(Utils.getCookie('SSOUser'));
      }

      if (params['org_code'] !== undefined) {
        this.getOrgCode(SSOUser ? SSOUser.TenantShortCode : params['org_code']);
      } else if (params['org_code'] === undefined && org && org.orgCode) {
        this.getOrgCode(SSOUser ? SSOUser.TenantShortCode : org.orgCode);
      } else {
        this.getOrgCode('undefined');
      }
    });
    this.checkCookie();
  }

  ngOnInit(): void {
    this.loadGoogleAnalyticsScript();
    this.setConfig();
  }

  ngAfterViewInit() {
    this.utilsService.assetPanelHeight();
    this.utilsService.exemplarAssetPanelHeight();
    this.utilsService.onDateRangeCalendarOpenClick();
    this.utilsService.showIEBrowserIncompatibleMsg();
  }

  /**
   * To set configuration
   *
   * @return void
   */
  public setConfig()
  {
    this.getConfigurations().subscribe(data => {
      GlobalSettings.setConfiguration(data[window.location.hostname], false);
    });
  }

  /**
   * creating a script tags
   *
   * @param scriptSrc
   *
   * @returns object
   */
  createScript(scriptSrc: any)
  {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = scriptSrc;
    script.async = true;
    return script;
  }

  checkCookie() {
    setInterval(() => {
      const cookieObj = document.cookie;
      if (cookieObj.indexOf('SSOUser') === -1 && cookieObj.indexOf('central_auth_token') === -1) {
        localStorage.removeItem('access_token');
      }
    }, 1000);
  }

  getOrgCode(org_code) {
    const url = GlobalSettings.GET_ORGANIZATION_CODE + '/' + org_code;
    this.service.getUserServiceDataWithoutTocken(url).then((res: any) => {
      this.orgCode = res['org_code'];
      this.orgId = res['organization_id'];
      this.orgLogoPath = res['branding_logo'] ? res['branding_logo'] : '';
      if (sessionStorage.getItem('frontface_url')) {
        const org = sessionStorage.getItem('frontface_url').split('/')[Utils.orgCodeIndex];
        localStorage.setItem('orgDetails', JSON.stringify({
          'orgCode': org,
          'orgId': '',
          'orgLogoPath': this.orgLogoPath
        }));
        this.setOrgId(org);
      } else {
        localStorage.setItem('orgDetails', JSON.stringify({
          'orgCode': this.orgCode,
          'orgId': this.orgId,
          'orgLogoPath': this.orgLogoPath
        }));
      }

      console.log('$$ org_code in APP', org_code, 'router.url', this.router.url, this.orgCode);
      if (this.router.url !== '/' + Utils.prefix.substr(0, (Utils.prefix.length - 1))) {
        sessionStorage.setItem('frontface_url', this.router.url);
        const org = sessionStorage.getItem('frontface_url').split('/')[Utils.orgCodeIndex];
        this.setOrgId(org);
      }

      try {
        if (org_code !== this.orgCode) {
          if (sessionStorage.getItem('current_url')) {
            console.log('$$ APP IF $$', '--org_code--', org_code, '--this.orgCode--', this.orgCode,
              [sessionStorage.getItem('current_url').split(',')[0]]);
            if (this.router.url.indexOf('register') === -1) {
              this.router.navigate([sessionStorage.getItem('current_url').split(',')[0]]);
            }
          } else {
            console.log('$$ APP ELSE $$', '--org_code--', org_code, '--this.orgCode--', this.orgCode, this.router.url);
            if (sessionStorage.getItem('frontface_url')) {
              if (this.router.url !== sessionStorage.getItem('frontface_url')) {
                this.router.navigate([sessionStorage.getItem('frontface_url')]);
              }
            } else {
              if (!window.location.href.includes('app') && !window.location.href.includes('taxonomies') &&
                !window.location.href.includes('public/info') && !window.location.href.includes('register')) {
                this.router.navigate([Utils.getURLPrefix(this.orgCode)]);
              }
            }

          }
        } else {
          console.log('Match Found App', window.location);
          if (!window.location.href.includes('app') && !window.location.href.includes('taxonomies') &&
            !window.location.href.includes('public/info') && !window.location.href.includes('register')) {
            this.router.navigate([Utils.getURLPrefix(this.orgCode)]);
          }
        }
      } catch (err) { }
    }).catch((err: any) => {
      console.log('Exception in get organisation app component', url);
    });
  }

  searchTriggered() {
    console.log('this.currentURL', this.currentURL);
    if (this.currentURL) {
      this.searchPlaceholder = this.currentURL.split('/')[this.currentURL.split('/').length - 2];
      if (this.searchPlaceholder === 'taxonomies') {
        this.searchPlaceholder = 'Taxonomies';
      }
      if (this.searchPlaceholder === 'pacingguides') {
        this.searchPlaceholder = 'Pacing Guide';
      }
      if ((this.currentURL.indexOf('taxonomies') !== -1) || (this.currentURL.indexOf('pacingguides') !== -1)) {
        this.searchTrigger = true;
      } else {
        this.searchTrigger = false;
      }
    } else {
      this.searchTrigger = false;
    }
  }

  setSearchTrigger($event) {
    this.searchTrigger = $event;
  }

  setOrgId(org_code) {
    const url = GlobalSettings.GET_ORGANIZATION_CODE + '/' + org_code;
    this.service.getUserServiceDataWithoutTocken(url).then((res: any) => {
      this.orgCode = res['org_code'];
      this.orgId = res['organization_id'];
      if (org_code === this.orgCode) {
        localStorage.setItem('orgDetails', JSON.stringify({
          'orgCode': this.orgCode,
          'orgId': this.orgId,
          'orgLogoPath': res['branding_logo'] ? res['branding_logo'] : ''
        }));
      }
    }).catch((err: any) => {
      console.log('Exception in get organisation app component setOrgId', url);
    });
  }

  /* --------- Functionality to fetch environment configuration start -------- */

  public getConfigurations(): Observable<any> {
    try {
      return this.http.get('./assets/json/envConfiguration.json');
    } catch (err) {
      console.log('Error fetching configurations')
    }
  }

  /* --------- Functionality to fetch environment configuration end -------- */



  /* --------- Functionality to load Google Analytics starts -------- */
  loadGoogleAnalyticsScript() {
    const gtagScript = document.createElement('script');
    gtagScript.type = 'text/javascript';
    gtagScript.innerHTML = 'window.dataLayer = window.dataLayer || [];' +
      'function gtag(){dataLayer.push(arguments);}' +
      'gtag("js", new Date());' +
      'gtag("config", "' + GlobalSettings.GOOGLE_ANALYTICS_ID + '");';
    const googleRefScript = document.createElement('script');
    googleRefScript.type = 'text/javascript';
    googleRefScript.async = true;
    googleRefScript.src = 'https://www.googletagmanager.com/gtag/js?id=' + GlobalSettings.GOOGLE_ANALYTICS_ID;
    const head = document.getElementsByTagName('head')[0];
    if (head !== null && head !== undefined) {
      document.head.appendChild(googleRefScript);
      document.head.appendChild(gtagScript);
    }
  }

  /* --------- Functionality to load Google Analytics ends -------- */

}
